import type { HttpErrorResponse } from '@angular/common/http';

import type { RecipientTypehead } from '@core/mailbox-types';
import { createEntityCollectionStore, getEntityCollectionActions } from '@core/ngrx-legacy';

const { actions, reducer, namespace, selectors } = createEntityCollectionStore<RecipientTypehead>()(
  'mailbox-contacts',
  {
    customActions: adapter => {
      const actions = getEntityCollectionActions(adapter, ({ id }) => id);

      return {
        search: (state, payload: { scope: string; query: string }) =>
          actions.fetchCollection(state, payload),
        searchSuccess: (state, payload: { data: RecipientTypehead[]; scope: string }) =>
          actions.fetchCollectionSuccess(state, { scope: payload.scope, data: payload.data }),
        searchFailed: (state, payload: { error: HttpErrorResponse; scope: string }) =>
          actions.fetchCollectionFailed(state, { scope: payload.scope, error: payload.error }),
      };
    },
  },
);

const MailboxContactsActions = <Pick<typeof actions, 'search' | 'searchSuccess' | 'searchFailed'>>(
  actions
);

export {
  MailboxContactsActions,
  actions,
  reducer as MailboxContactsReducer,
  namespace as MailboxContactsNamespace,
  selectors as MailboxContactsSelectors,
};
